<template>
  <div class="margin-1 pega-table-sp">
    <h6>■職種設定</h6>
    <job-content-table :title="offerPointTitle">
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="給与コード"
        :value="jobCategorySettings.offerPoint.salary"
      />
      <job-content-table-outline
        title="職種[1]"
        :value="jobCategorySettings.offerPoint.jobName1"
      />
      <job-content-table-outline
        title="職種[2]"
        :value="jobCategorySettings.offerPoint.jobName2"
      />
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="対象学歴"
        :value="jobCategorySettings.offerPoint.educationTarget"
      />
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="年齢"
        :value="jobCategorySettings.offerPoint.ageFromTo"
      >
        <br>
        <a @click="openBossSAgeRegulation">［PDF］年齢制限の禁止について</a>
      </job-content-table-outline>
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="年収"
        :value="jobCategorySettings.offerPoint.annualIncomeFromTo"
      />
      <job-content-table-outline
        title="外部表示用職種名"
        :value="jobCategorySettings.offerPoint.externalJobName"
      />
    </job-content-table>

    <job-content-table title="会社について">
      <job-content-table-outline
        title="正式社名"
        :value="jobCategorySettings.aboutCompany.formalName"
      >
        <br>
        <span class="notice">※支店名、事業部名、グループ名等の入力不可。</span>
        <span
          v-if="jobCategorySettings.aboutCompany.isVisibleInGoogle"
          class="notice"
          data-test="isVisibility"
        >※提携サイト掲載時にこちらの社名が使用されます。</span>
      </job-content-table-outline>
      <job-content-table-outline
        title="表示用社名"
        :value="jobCategorySettings.aboutCompany.displayName"
      >
        <br>
        <span
          v-if="!jobCategorySettings.aboutCompany.isVisibleInGoogle"
          class="notice"
        >※提携サイト掲載時にこちらの社名が使用されます。</span>
      </job-content-table-outline>
      <job-content-table-outline
        title="業種名"
        :value="jobCategorySettings.aboutCompany.businessName"
      />
    </job-content-table>

    <job-content-table title="設定済PRコード一覧">
      <template
        v-if="!isCompanyStaffAccess"
        #title
      >
        (<a @click="openBossSPRCodes()">すべてのPRコード</a>)
      </template>
      <template #default>
        <job-content-table-outline
          title="アピールポイント"
          :value="jobCategorySettings.configuredPrContents.normalPrContents"
        />
        <job-content-table-outline
          title="特集用検索コード"
          :value="jobCategorySettings.configuredPrContents.uraPrContents"
        />
        <job-content-table-outline
          title="エンジニア系特集用検索コード"
          :value="jobCategorySettings.configuredPrContents.uraEngineerPrContents"
        />
        <job-content-table-outline
          title="サービス・販売系特集用検索コード"
          :value="jobCategorySettings.configuredPrContents.uraServicePrContents"
        />
      </template>
    </job-content-table>

    <job-content-table title="専用応募フォーム">
      <job-content-table-outline
        title="設定URL"
        :value="jobCategorySettings.applyUrl"
      >
        <template
          v-if="jobCategorySettings.applyUrl"
          #body
        >
          <a
            :href="jobCategorySettings.applyUrl"
            class="pega-break text-underline"
            rel="nofollow"
            target="blank"
            v-text="jobCategorySettings.applyUrl"
          />
        </template>
      </job-content-table-outline>
    </job-content-table>

    <job-content-table :title="questionTitle">
      <job-content-table-outline
        v-for="index in [1,2,3]"
        :key="`question-${index}`"
        :title="`独自質問${index}`"
        :value="questionItems[`question${index}`]"
      />
    </job-content-table>

    <job-content-table title="情報提供">
      <job-content-table-outline
        title="外部連携データ"
        :value="jobCategorySettings.providedInfo"
      />
    </job-content-table>
  </div>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    JobContentTable,
    JobContentTableOutline
  },
  mixins: [jobPreviewCommon],
  props: {
    jobCategorySettings: {
      type: Object,
      required: true
    }
  }
}
</script>
